/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractGridInputCellEditorComponent } from './abstract-grid-input-cell-editor.component';

@Component({
  selector: 'gh-grid-masked-cell-editor',
  template: require('./grid-masked-cell-editor.component.html'),
  styles: [require('./grid-input-cell-editor.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridMaskedCellEditorComponent extends AbstractGridInputCellEditorComponent {
}
